// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fKHg","buttons":"styles_buttons__zKTRk"};